/* eslint-disable react/forbid-prop-types */
/* eslint-disable camelcase */
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Row from 'antd/es/row';
import Col from 'antd/es/col';
import SwipeableViews from 'react-swipeable-views';

import CreateCustomerModal from '../../components/Modals/CreateCustomer.modal';
import { loadCustomers } from '../../redux/ActionsAndReducers/Customers';
import { requestExportData } from '../../redux/ActionsAndReducers/Ui';
import CardLayout from '../../components/CardLayout';
import renderMixin from '../../mixins/customer.render.mixin';
import { showSiderAction, hideSiderAction } from '../../redux/sider/actions';
import {
  toggle_customer_filter_state_action,
  toggle_create_customer_modal_action,
  saveFilterAction,
} from '../../redux/app/actions';
import './style.css';

class CustomersScreen extends renderMixin(CardLayout) {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      searchValue: '',
      sortValues: {},
    };
  }

  componentDidMount() {
    super.componentDidMount();
    const { _loadCustomers, items, toggleCustomerFilterState } = this.props;
    if (!items || items.length <= 1) {
      toggleCustomerFilterState(false);
      _loadCustomers();
    }
  }

  render() {
    const { items, isLoading } = this.props;
    const leftContent = (
      <>
        {this.renderSider('mobile')}
        <Col
          xs={24}
          sm={24}
          md={12}
          lg={8}
          xl={6}
          style={{
            overflowY: 'auto',
            height: `${window.innerHeight - 85}px`,
            position: 'relative',
          }}
        >
          {this.renderSideHeaderCard()}
          <CreateCustomerModal />
          {isLoading ? this.renderSkeleton() : this.renderCards(items)}
          {this.renderPaginationCard()}
        </Col>
      </>
    );

    const rightContent = (
      <Col
        xs={24}
        sm={24}
        md={12}
        lg={16}
        xl={18}
        style={{
          position: 'relative',
          height: `${window.innerHeight - 85}px`,
          backgroundColor: 'rgb(240, 242, 245)',
          overflowY: 'auto',
        }}
      >
        {this.renderKpisAndDetails(items)}
        {!this.isMobile() && this.renderSider('desktop')}
      </Col>
    );

    return this.isMobile() ? (
      <>
        <Row gutter={16} style={{ backgroundColor: '#f0f2f5' }}>
          <SwipeableViews>
            {leftContent}
            {rightContent}
          </SwipeableViews>
        </Row>
      </>
    ) : (
      <>
        <Row gutter={16} style={{ backgroundColor: '#f0f2f5' }}>
          {leftContent}
          {rightContent}
        </Row>
      </>
    );
  }
}

CustomersScreen.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  total: PropTypes.number.isRequired,
  stats: PropTypes.shape({
    count: PropTypes.number,
    ordersCount: PropTypes.number,
    ordersAmount: PropTypes.number,
    returnRate: PropTypes.number,
    avgOrdersNum: PropTypes.number,
    avgAmount: PropTypes.number,
  }).isRequired,

  _loadCustomers: PropTypes.func.isRequired,
  onExport: PropTypes.bool.isRequired,
  _requestExportData: PropTypes.func.isRequired,
  toggleCustomerFilterState: PropTypes.func.isRequired,
  isFiltered: PropTypes.bool.isRequired,
  pagination: PropTypes.any,
};

const mapDispatchToProps = (dispatch) => ({
  _loadCustomers: (opts) => dispatch(loadCustomers(opts)),
  _requestExportData: (model, filters = {}) => dispatch(requestExportData(model, filters)),
  showSider2: (...args) => dispatch(showSiderAction(...args)),
  hideSider2: (...args) => dispatch(hideSiderAction(...args)),
  toggleCustomerFilterState: (...args) =>
    dispatch(toggle_customer_filter_state_action(...args)),
  showCreateModal: () => dispatch(toggle_create_customer_modal_action()),
  saveFilter: (...args) => dispatch(saveFilterAction(...args)),
});

const mapStateToProps = ({ Customers, Ui, app, sider }) => ({
  isLoading: Customers.isLoading,
  items: Customers.customers,
  columns: Customers.columns,
  stats: Customers.stats?.data,
  statsLoaded: Customers.stats?.loaded,
  total: Customers.total,
  onExport: Ui.onExport.customers,
  isFiltered: app.customer.filtered,
  siderData: sider.data,
  sider2IsVisible: sider.visible,
  pagination: Customers.pagination,
  configFilters: app.filters.customers || { search: null, sorters: {} },
});

export default connect(mapStateToProps, mapDispatchToProps)(CustomersScreen);
